export default __webpack_public_path__ + "542d4930de15d99be736f36e8cb3d659.ttf";